import {
  apiContainer,
  normalizeApiParams,
  PaginatedResponse,
  serializeJSONToString,
  StateId,
} from '@wallaby-ui/core';
import {get, isEmpty, isEqual} from 'lodash';

import {GridParams, gridSlice} from './grid_slice';
import {changeQueryParams} from 'src/js/containers/filter_and_search/filter_and_search_thunks';
import {AppThunk} from 'src/js/store';

export function changeGridParamsAndQuery(
  stateId,
  gridParams: GridParams,
  filterAndSearchStateId,
  gridsApiStateId,
  requestUrl,
  urlParams,
  paramsPrefix?: string
): AppThunk {
  return (dispatch) =>
    Promise.all([
      dispatch(
        gridSlice.actions.changeGridParams(stateId, {params: gridParams})
      ),
    ]).then(() => {
      let resultDispatch;
      if (filterAndSearchStateId) {
        resultDispatch = dispatch(
          changeQueryParams(filterAndSearchStateId, urlParams, paramsPrefix)
        );
      } else if (gridsApiStateId) {
        resultDispatch = dispatch(
          apiContainer.apiSlice.actions.changeApiParams(
            gridsApiStateId,
            normalizeApiParams(urlParams)
          )
        );
      }
      return resultDispatch;
    });
}

export function loadGridConfig(stateId, configPath, reload = false): AppThunk {
  return (dispatch, getState, {config}) => {
    const staticConfig = get(config, configPath);
    return dispatch(
      gridSlice.actions.setGridConfig(stateId, {
        config: staticConfig,
        reload,
      })
    );
  };
}

export function recoverGridParams(
  gridStateId: StateId,
  paginationData: Omit<PaginatedResponse<any>, 'content'>,
  gridParams: GridParams
): AppThunk {
  return (dispatch) => {
    const newGridParams = {
      ...(isEqual(paginationData.number + 1, gridParams?.pagination?.page)
        ? {}
        : {page: paginationData.number + 1}),
      ...(isEqual(paginationData.size, gridParams?.pagination?.pageSize)
        ? {}
        : {size: paginationData.size}),
    };

    if (
      !isEmpty(paginationData) &&
      !isEmpty(gridParams.pagination) &&
      !isEmpty(newGridParams)
    ) {
      dispatch(
        gridSlice.actions.changeGridParams(gridStateId, {
          params: newGridParams,
        })
      );
    }
  };
}

export function changeMemorizeColumnStates(
  gridStateId: StateId,
  filterAndSearchStateId: StateId | undefined,
  featureName: string | undefined,
  columnStateChange
): AppThunk {
  return (dispatch) => {
    dispatch(
      gridSlice.actions.memorizeColumnStates(gridStateId, columnStateChange)
    );
    dispatch(
      changeQueryParams(
        filterAndSearchStateId,
        {memorizedColumnStates: serializeJSONToString(columnStateChange)},
        featureName
      )
    );
  };
}
